export default from './page';



// WEBPACK FOOTER //
// ./app/components/page/index.js